export default "__VITE_ASSET__$mZLFZe5__"